// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumbs_root__24W31","breadcrumb":"Breadcrumbs_breadcrumb__3NVQa","active":"Breadcrumbs_active__2HkO9","arrow":"Breadcrumbs_arrow__3WfbD"};